import * as React from "react"

import ContextualHelpButton from "../../contextualhelp/components/ContextualHelpButton"
import CreateNewItemButton from "./CreateNewItemButton"
import HomeButton from "./HomeButton"
import Navigation from "./navigation/components/Navigation"
import PendingNotificationsButton from "./pendingnotifications/components/PendingNotificationsButton"
import SmartLocation from "./smartlocation/components/SmartLocation"
import SimpleSearch from "../../search/simple/SimpleSearch"
import SmartSearch from "../../search/smart/components/SmartSearch"
import UserMenu from "./usermenu/components/UserMenu"
import { Labels } from "../../../util/Translations"
import { ISearch } from "../../search"

interface Props extends Partial<ISearch> {
    isCniEnabled: boolean
    isContextualHelpEnabled: boolean
    isSmartSearch: boolean
}

export const ApplicationHeader = ({
    isSmartSearch,
    isCniEnabled,
    isContextualHelpEnabled,
}: Props): JSX.Element => {
    const {
        CreateNewItem,
        LoadMore,
        Notifications,
        NoResultsFound,
        SmartLocationFilter,
        Home,
    } = Labels
    return (
        <header
            className="tw-flex tw-items-center tw-flex-row tw-py-2 tw-mx-4"
            id="applicationHeader"
        >
            <div className="tw-flex tw-items-center justify-start">
                <Navigation />
                <HomeButton label={Home} />
            </div>
            <div
                className="tw-flex tw-items-center tw-flex-grow tw-flex-wrap tw-px-2"
                id="smartLocationContainer"
            >
                <SmartLocation
                    loadMoreLabel={LoadMore}
                    noResultsLabel={NoResultsFound}
                    smartLocationFilterLabel={SmartLocationFilter}
                />
            </div>
            <div className="tw-flex tw-items-center tw-justify-end">
                {isCniEnabled && <CreateNewItemButton label={CreateNewItem} />}
                {isSmartSearch ? <SmartSearch /> : <SimpleSearch />}
                {isContextualHelpEnabled && <ContextualHelpButton />}
                <PendingNotificationsButton label={Notifications} />
                <UserMenu />
            </div>
        </header>
    )
}

export default ApplicationHeader
